// src/components/warehouse/WarehouseGate.tsx
// C-I8 (Welle W): Route-Guard fuer die Lager-Masken. Bisher gab es Sidebar-Gating
// (welche Links angezeigt werden) und punktuelle In-Page-Gates (z.B.
// InventurZaehlenPage), aber keinen zentralen Schutz auf Routen-Ebene — ein Nutzer
// mit nur 'general' konnte /warehouse/leiter oder /warehouse/einlagern direkt per
// URL aufrufen und lief dort in einen 403 der Backend-API statt eine klare
// Berechtigungsmeldung zu sehen. Diese Komponente spiegelt die Backend-Matrix
// general/book/count/lead/admin (src/modules/warehouse/guards.ts hasWarehouseLevel)
// 1:1 auf Routen-Ebene.
import type { ReactNode } from 'react'
import { useAuth } from '@/api/auth'

export type WarehouseLevel = 'general' | 'book' | 'count' | 'lead' | 'admin'

export function WarehouseGate({ level, children }: { level: WarehouseLevel; children: ReactNode }) {
  const { warehouse } = useAuth()
  if (!warehouse[level]) {
    return (
      <div className="p-8 max-w-lg mx-auto text-center space-y-2">
        <div className="text-lg font-bold text-red-700">Keine Berechtigung</div>
        <div className="text-sm text-muted">
          Für diesen Bereich fehlt die Lager-Berechtigung „{level}". Bitte beim Leiter oder Admin melden.
        </div>
      </div>
    )
  }
  return <>{children}</>
}
